import { Injectable } from '@angular/core';
import * as data from '@asset-old/assets/mensagens.data.json';
import { IMensagens } from './mensagens.model';

@Injectable()
export class MensagensAplicacaoService {
  static mensagens: IMensagens;

  constructor() {}

  private static carregar() {
    // const arquivoDeMensagens = 'assets/mensagens.data.json';
    return new Promise<void>((resolucao, rejeicao) => {
      MensagensAplicacaoService.mensagens = <IMensagens><unknown>data;
    });
  }

  static retornaMensagens(): IMensagens {
    if (MensagensAplicacaoService.mensagens == null) {
      this.carregar();
    }

    return MensagensAplicacaoService.mensagens;
  }
}
export const MensagensService: IMensagens =
  MensagensAplicacaoService.retornaMensagens();
